import apiGroupDefinition from './api-group';
import DeleteAssetModal from './common/DeleteAssetModal';

const getPortalDefinition = (assetTypeDefinitions, assetType) => {
  const apiType = { DeleteAssetModal };
  const typesWithManagedInstances = Object.keys(assetTypeDefinitions).filter(
    (type) => assetTypeDefinitions[type].hasManagedInstances
  );
  const configurations = typesWithManagedInstances.reduce(
    (accum, type) => ({ ...accum, [type]: apiType }),
    { 'api-group': apiGroupDefinition }
  );

  return configurations[assetType];
};

export default getPortalDefinition;
